(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- money ---------- */
  function num(cents, dec, thou, decp) {
    var v = (cents / 100).toFixed(dec).split('.');
    v[0] = v[0].replace(/(\d)(?=(\d{3})+$)/g, '$1' + thou);
    return v[0] + (v[1] ? decp + v[1] : '');
  }
  function formatMoney(cents) {
    var fmt = (window.CHEZEIN && window.CHEZEIN.moneyFormat) || 'Rs. {{amount}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, f) {
      switch (f) {
        case 'amount_no_decimals': return num(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return num(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return num(cents, 2, "'", '.');
        default: return num(cents, 2, ',', '.');
      }
    });
  }

  /* ---------- toast ---------- */
  var toastTimer;
  function showToast(msg) {
    var t = $('#toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('show'); }, 2600);
  }

  /* ---------- cart drawer ---------- */
  var onCartPage = document.body.classList.contains('template-cart');
  function toggleCart(open) {
    var drawer = $('.cart-drawer'), overlay = $('.overlay');
    if (!drawer) return;
    drawer.classList.toggle('open', open);
    overlay.classList.toggle('open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.style.overflow = open ? 'hidden' : '';
  }
  function refreshCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }
  function renderCart(cart) {
    $$('.cart-count').forEach(function (el) {
      el.textContent = cart.item_count;
      el.setAttribute('data-count', cart.item_count);
    });
    var itemsEl = $('#cartDrawerItems'), footEl = $('#cartDrawerFoot');
    if (!itemsEl) return;
    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<div class="cart-empty">Your cart is empty.<br>Add a product to see it here.</div>';
      if (footEl) footEl.style.display = 'none';
      return;
    }
    var html = '';
    cart.items.forEach(function (item, idx) {
      var line = idx + 1;
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<div class="var">' + esc(item.variant_title) + '</div>' : '';
      var img = item.image ? '<img src="' + esc(item.image) + '" alt="' + esc(item.product_title) + '" loading="lazy">' : '';
      html += '<div class="cart-line">' +
        '<div class="thumb">' + img + '</div>' +
        '<div class="info"><b><a href="' + esc(item.url) + '">' + esc(item.product_title) + '</a></b>' + variant +
        '<div class="line-controls">' +
          '<div class="qty">' +
            '<button type="button" class="js-line-change" data-line="' + line + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button>' +
            '<input type="text" value="' + item.quantity + '" readonly aria-label="Quantity">' +
            '<button type="button" class="js-line-change" data-line="' + line + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<button type="button" class="remove js-line-change" data-line="' + line + '" data-qty="0">Remove</button>' +
        '</div></div>' +
        '<div class="line-price">' + formatMoney(item.final_line_price) + '</div>' +
        '</div>';
    });
    itemsEl.innerHTML = html;
    if (footEl) {
      footEl.style.display = 'block';
      var sub = $('#cartDrawerSubtotal');
      if (sub) sub.textContent = formatMoney(cart.total_price);
    }
  }
  function changeLine(line, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(qty) })
    }).then(function (r) { return r.json(); });
  }

  /* ---------- clicks ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var el;

    if ((el = t.closest('.js-nav-open'))) { document.body.classList.add('nav-open'); return; }
    if ((el = t.closest('.js-nav-close'))) { document.body.classList.remove('nav-open'); return; }

    if ((el = t.closest('.js-search-toggle'))) {
      var panel = $('[data-search-panel]');
      if (panel) {
        panel.hidden = !panel.hidden;
        if (!panel.hidden) { var inp = $('input[name="q"]', panel); if (inp) inp.focus(); }
      }
      return;
    }

    if ((el = t.closest('.js-cart-open'))) {
      if (onCartPage || !$('.cart-drawer')) return; // let the link go to /cart
      e.preventDefault();
      refreshCart().then(function () { toggleCart(true); });
      return;
    }
    if (t.closest('.js-cart-close')) { toggleCart(false); return; }

    if ((el = t.closest('.js-qty'))) {
      var input = $('input', el.closest('.qty'));
      var step = Number(el.getAttribute('data-step')) || 0;
      var v = Math.max(1, (parseInt(input.value, 10) || 1) + step);
      input.value = v;
      return;
    }

    if ((el = t.closest('.js-line-change'))) {
      e.preventDefault();
      changeLine(el.getAttribute('data-line'), el.getAttribute('data-qty')).then(function (cart) {
        if (onCartPage) { window.location.reload(); } else { renderCart(cart); }
      });
      return;
    }

    if ((el = t.closest('.js-thumb'))) {
      var idx = el.getAttribute('data-index');
      $$('.js-thumb').forEach(function (b) { b.classList.toggle('is-active', b === el); });
      $$('.pdp-slide').forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-index') === idx); });
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { toggleCart(false); document.body.classList.remove('nav-open'); }
  });

  /* ---------- add to cart (AJAX); Buy Now goes straight to checkout ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-add-to-cart]');
    if (!form) return;
    if (e.submitter && e.submitter.name === 'checkout') return; // native submit -> checkout
    e.preventDefault();
    var btn = e.submitter;
    if (btn) btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) { throw new Error('add failed'); } return r.json(); })
      .then(function () {
        showToast('Added to cart');
        return refreshCart();
      })
      .then(function () { if (!onCartPage) { toggleCart(true); } })
      .catch(function () { showToast('Could not add this item. Please try again.'); })
      .then(function () { if (btn) btn.disabled = false; });
  });

  /* ---------- collection sort + filters ---------- */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('.js-sort')) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', t.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    }
    if (t.closest('.js-filter-form')) { t.closest('form').submit(); }
  });

  document.addEventListener('DOMContentLoaded', function () {
    refreshCart();
    var fp = $('[data-filters-panel]');
    if (fp && window.matchMedia('(min-width: 901px)').matches) { fp.open = true; }
  });
})();
